import React from 'react';

import { FeedbackConfirmed } from './Confirmed';
import { FeedbackExpired } from './Expired';
import { FeedbackLoading } from './Loading';

export namespace RateManagementPillButtonTypes {
  export interface Props {
    currentFeedback?: 'loading' | 'confirmed' | 'expired';
    isMobile: boolean;
  }
}
export const Feedback: React.FC<RateManagementPillButtonTypes.Props> = ({
  currentFeedback,
  isMobile,
}) => {
  const content = {
    loading: <FeedbackLoading isMobile={isMobile} />,
    confirmed: <FeedbackConfirmed isMobile={isMobile} />,
    expired: <FeedbackExpired isMobile={isMobile} />,
  };

  if (!currentFeedback) {
    return null;
  }

  return content[currentFeedback];
};
